__turbopack_context__.v({
  "section-image-text": "h4S7-q_section-image-text",
  "section-image-text--loaded": "h4S7-q_section-image-text--loaded",
  "section-image-text__inner": "h4S7-q_section-image-text__inner",
  "section-image-text__parallax-container": "h4S7-q_section-image-text__parallax-container",
  "section-image-text__text": "h4S7-q_section-image-text__text",
});
